import React from 'react';

import { StyledArrows } from './Arrows.styles';

import { ArrowsProps } from './Arrows.types';
import { NextArrow, PreviousArrow } from '../Arrow';

const Arrows = ({
  componentClassname = 'arrows-list',
  customClassnames = '',
  arrowComponentClassname = 'arrow',
  arrowComponentCustomClassnames = '',
  prevArrowChildren,
  nextArrowChildren,
  sliderDispatch,
  isInfinite,
  sliderState,
  ...props
}: ArrowsProps) => {
  return (
    <StyledArrows
      {...props}
      className={`${componentClassname} ${customClassnames}`}
    >
      <PreviousArrow
        componentClassname={arrowComponentClassname}
        customClassnames={arrowComponentCustomClassnames}
        sliderDispatch={sliderDispatch}
        isHidden={!isInfinite && sliderState.currentSlideIndex <= 0}
        children={prevArrowChildren}
      />
      <NextArrow
        componentClassname={arrowComponentClassname}
        customClassnames={arrowComponentCustomClassnames}
        sliderDispatch={sliderDispatch}
        isHidden={
          !isInfinite && sliderState.currentSlideIndex >= sliderState.maxIndex
        }
        children={nextArrowChildren}
      />
    </StyledArrows>
  );
};
Arrows.displayName = 'Arrows';

export default Arrows;
